import React from 'react'
import styled from 'styled-components'

import { connect } from 'react-redux'
import * as actions from '../../actions'

import Speaker from '../visuals/Speaker'

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({
  onPlay: (track) => {
    dispatch(actions.loadTrack(track))
    dispatch(actions.toggleCurrentTrack(true))
  }
})

const Button = styled.span`
  display: none;
  width: 100%;
  height: 100%;

  /* Pixel perfection :P */
  position: relative;
  top: 1px;
`

class PlayButton extends React.Component {
  render () {
    return (
      <Button className={this.props.additionalClassName} onClick={() => this.props.onPlay(this.props.track)}>
        <Speaker width={15} />
      </Button>
    )
  }
}


PlayButton = connect(mapStateToProps, mapDispatchToProps)(PlayButton)

export default PlayButton



// WEBPACK FOOTER //
// ./src/components/Main/PlayButton.js